var data = [
  { city: "重庆", company: "超硅半导体", produc: "8英寸600万片、12英寸60万片" },
  { city: "上海", company: "超硅半导体", produc: "12英寸360万片" },
  {
    city: "银川",
    company: "银和半导体",
    produc: "8英寸420万片、12英寸240万片",
  },
  { city: "杭州", company: "中欣晶圆", produc: "8英寸540万片、12英寸288万片" },
  { city: "徐州", company: "协鑫", produc: "8/12英寸360万片" },
  { city: "德州", company: "有研艾斯", produc: "8英寸180万片、12英寸360万片" },
  { city: "宜兴", company: "中环领先", produc: "8英寸900万片、12英寸720万片" },
  { city: "上海", company: "上海新昇", produc: "360万片" },
  { city: "衢州", company: "金瑞泓", produc: "8英寸480万片、12英寸120万片" },
  { city: "嘉兴", company: "中晶半导体", produc: "12英寸480万片" },
  { city: "郑州", company: "合晶", produc: "8英寸240万片、12英寸240万片" },
];
var geoCoordMap = {
  重庆: [106.54, 29.59],
  上海: [121.48, 31.22],
  银川: [106.27, 38.47],
  杭州: [120.19, 30.26],
  徐州: [117.2, 34.26],
  德州: [116.29, 37.45],
  宜兴: [119.82, 31.36],
  衢州: [118.88, 28.97],
  嘉兴: [120.76, 30.77],
  郑州: [113.65, 34.76],
};
var convertData = function (data) {
  var res = [];
  for (var i = 0; i < data.length; i++) {
    var geoCoord = geoCoordMap[data[i].city];
    if (geoCoord) {
      res.push({
        city: data[i].name,
        value: geoCoord.concat(data[i].city, data[i].company, data[i].produc),
        //value: value.concat(data[i].produc)
        //company: data.company,
        //produc: data.produc
      });
    }
  }
  return res;
};

export default {
  title: {
    subtext: "",
    sublink: "",
    left: "center",
  },
  textStyle: {
    fontSize: 28,
  },
  bmap: {
    center: [113.114129, 33.550339],
    zoom: 7,
    roam: true,
    mapStyle: {
      styleJson: [
        {
          featureType: "water",
          elementType: "all",
          stylers: {
            color: "#022448",
          },
        },
        {
          featureType: "land",
          elementType: "all",
          stylers: {
            color: "#01396a",
          },
        },
        {
          featureType: "railway",
          elementType: "all",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "highway",
          elementType: "all",
          stylers: {
            visibility: "off",
            color: "#fdfdfd",
          },
        },
        {
          featureType: "highway",
          elementType: "labels",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "arterial",
          elementType: "geometry",
          stylers: {
            color: "#6effff",
          },
        },
        {
          featureType: "arterial",
          elementType: "geometry.fill",
          stylers: {
            color: "#fefefe",
          },
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "green",
          elementType: "all",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "subway",
          elementType: "all",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "manmade",
          elementType: "all",
          stylers: {
            color: "#d1d1d1",
          },
        },
        {
          featureType: "local",
          elementType: "all",
          stylers: {
            color: "white",
          },
        },
        {
          featureType: "arterial",
          elementType: "labels",
          stylers: {
            visibility: "off",
          },
        },
        {
          featureType: "boundary",
          elementType: "all",
          stylers: {
            color: "#6effff",
          },
        },
        {
          featureType: "building",
          elementType: "all",
          stylers: {
            color: "#d1d1d1",
          },
        },
        {
          featureType: "label",
          elementType: "all",
          stylers: {
            color: "#6effff",
          },
        },
        {
          featureType: "label",
          elementType: "labels.text.stroke",
          stylers: {
            color: "#01396a",
          },
        },
      ],
    },
  },
  series: [
    {
      name: "硅片厂商进展",
      type: "scatter",
      coordinateSystem: "bmap",
      data: convertData(data),
      symbolSize: 30,
      encode: {
        value: 5,
      },
      itemStyle: {
        color: "#5d0799",
      },
      data1: data,
      label: {
        formatter: "{a|{@3}}({@2}): {b|{@4}} ",
        backgroundColor: "white",
        borderColor: "#aaa",
        borderWidth: 1,
        borderRadius: 5,
        padding: 4,
        rich: {
          a: {
            color: "#000",
            align: "center",
          },
          b: {
            color: "#000",
          },
        },
        position: "left",

        show: true,
      },
    },
  ],
};
